import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';

export function inputAreaSetActive(tgEl: any): void {
  if (tgEl.classList.contains('input-area__inactive')) {
    tgEl.classList.remove('input-area__inactive');
    tgEl.classList.add('input-area__active');
    tgEl.querySelector('input').focus();
  }
}

export function selectSetActive(tgEl: any): void {
  if (tgEl.classList.contains('input-area__inactive')) {
    tgEl.classList.remove('input-area__inactive');
    tgEl.classList.add('input-area__active');
    tgEl.querySelector('.custom').focus();
  }
}

export function checkIsInputArea(target: HTMLElement) {
  return (
    target.parentElement.classList.contains('input-area__active') ||
    target.parentElement.classList.contains('input-area__inactive') ||
    target.classList.contains('input-area__active') ||
    target.classList.contains('input-area__inactive')
  );
}

export function updateAreaActiveDependsOnValue(el: HTMLElement): void {
  if (!el) {
    return;
  }
  if (el.querySelector('input')?.value?.length > 0) {
    el.classList.remove('input-area__inactive');
    el.classList.add('input-area__active');
  } else {
    el.classList.add('input-area__inactive');
    el.classList.remove('input-area__active');
  }
}

export function clickoutCloseInput(event: any): void {
  if (!event?.target?.parentElement?.classList) {
    return;
  }
  let items = event.currentTarget.querySelectorAll(
    "[class*='input-container']"
  );

  if (checkIsInputArea(event.target)) {
    const filteredEl = event.target.parentElement.querySelector('input');
    items = _.filter(items, (x) => !x.contains(filteredEl));
  }
  changeInputVisibleStateAll(items);
}

export function changeInputVisibleStateAll(arrayData: NodeList): void {
  arrayData.forEach((el: any) => {
    const inputField = el.querySelector('input');
    if (inputField) {
      updateAreaActiveDependsOnValue(el);
    }
  });
}

/**
 * paste hyphens on input (in dynamic)
 * @param e - event
 * @param targetElement - input element
 * @returns targetElement
 */
export function mobileHyphensComplete(e: any, targetElement: any): any {
  const phone = e.target.value;

  const mobArray = Array.from(phone);
  const plusPosition = 0;
  const firstDupletPosition = 2;
  const secondDupletPosition = 5;
  const thirdDupletPosition = 8;
  const forthDupletPosition = 11;
  const fifthDupletPosition = 14;
  if (phone.length > firstDupletPosition + 1) {
    if (
      mobArray[plusPosition] === '+' &&
      mobArray[firstDupletPosition] === ' ' &&
      mobArray[secondDupletPosition] === ' ' &&
      mobArray[thirdDupletPosition] === ' ' &&
      mobArray[forthDupletPosition] === ' ' &&
      mobArray[fifthDupletPosition] === ' '
    ) {
      return e.target;
    }
  }

  if (
    (phone.length === firstDupletPosition ||
      phone.length === secondDupletPosition ||
      phone.length === thirdDupletPosition ||
      phone.length === forthDupletPosition) &&
    e.inputType !== 'deleteContentBackward'
  ) {
    targetElement.value = insertSymbol(mobArray, mobArray.length, ' ');
    return targetElement;
  }

  if (
    (phone.length === firstDupletPosition + 1 ||
      phone.length === secondDupletPosition + 1 ||
      phone.length === thirdDupletPosition + 1 ||
      phone.length === forthDupletPosition + 1 ||
      phone.length === fifthDupletPosition + 1) &&
    e.inputType === 'deleteContentBackward'
  ) {
    targetElement.value = deleteSymbol(mobArray, ' ');
    return targetElement;
  }
}

/**
 * place charSymbol into arr by position;
 * @param arr - arr where to place
 * @param position - can be arr.length
 * @param charSymbol - e.g. /
 * @returns new string
 */
function insertSymbol(
  arr: any[],
  position: number,
  charSymbol: string
): string {
  arr.splice(position, 0, charSymbol);
  return arr.join('');
}

/**
 * remove charSymbol from arr (by lastIndexOf);
 * @param arr - arr where to place
 * @param charSymbol - e.g. /
 * @returns new string
 */
function deleteSymbol(arr: any[], charSymbol: string): string {
  const i = arr.lastIndexOf(charSymbol);
  if (i !== -1) {
    arr.splice(i, 1);
  }
  return arr.join('');
}

/**
 * splits date by /, add '0' if need and return
 * @param input - date string
 * @returns new string
 */
function pasteZeros(input: string): string {
  const res = input.split('/');
  if (res.length === 3) {
    if (res[0].length === 1) {
      res[0] = '0' + res[0];
    }
    if (res[1].length === 1) {
      res[1] = '0' + res[1];
    }
    return res.join('/');
  }
  return input;
}

/**
 * for date - paste zeros & paste / in correct positions
 * @param input - date
 * @returns new date
 */
export function dateDashesSetInstead(input: string): string {
  const dateOfBirth = input;

  // at first paste zeros
  const allZerosCompleted = pasteZeros(dateOfBirth);

  const noDashes = allZerosCompleted.split('/').join('');

  const noDashesArray = Array.from(noDashes);
  const firstTripletPosition = 2;
  const secondTripletPosition = 5;
  let targetElement: string;

  if (noDashesArray.length > firstTripletPosition) {
    targetElement = insertSymbol(noDashesArray, firstTripletPosition, '/');
  }
  if (noDashesArray.length > secondTripletPosition) {
    targetElement = insertSymbol(noDashesArray, secondTripletPosition, '/');
  }

  return targetElement;
}

export function setDateAfterChangeAllDashes(that, document): void {
  const inpt = document.getElementById('dobInputId');
  inpt.addEventListener('focusout', (event: any) => {
    const val = event.target.value;
    if (!val || val.length === 0) {
      return;
    }
    const newVal = dateDashesSetInstead(val);
    if (val !== newVal) {
      that.infoForm.get('birthday').setValue(newVal);
    }
  });
}

export function isDateValidator(): ValidatorFn {
  const MDY_FORMAT = 'DD/MM/YYYY';
  return (control: AbstractControl): { [key: string]: any } | null => {
    const years16Ago = moment().subtract(15, 'years');
    const years120Ago = moment().subtract(120, 'years');
    // check no valid date
    const inputDateMoment = moment(control.value, MDY_FORMAT, false);
    let forbidden = !inputDateMoment.isValid();
    // check if user >= 18 years old but not older than 120
    if (!forbidden && (inputDateMoment.toDate() >= years16Ago.toDate() || inputDateMoment.toDate() < years120Ago.toDate())) {
      forbidden = true;
    }
    return forbidden ? { forbiddenName: { value: control.value } } : null;
  };
}

/**
 * manipulate targetElement classes & focus input / click select
 * @param targetElement div of other container
 * @param apply - is set active is neccessary
 */
export function inputSelectAriaCheckActiveState(
  targetElement: any,
  apply?: boolean
): void {
  if (targetElement.classList.contains('input-area__inactive') || apply) {
    targetElement.classList.remove('input-area__inactive');
    targetElement.classList.add('input-area__active');

    const input = targetElement.querySelector('input');
    if (input) {
      input.focus();
    }
    const select = targetElement.querySelector('select');
    if (select) {
      select.click();
    }
  }
}

/**
 * set Enter / Tab  press event on inputs
 * @param i - index of element formControlsInputId
 */
function enterAndTabHandler(that: any, event, i): void {
  if (event.key === 'Enter' || (event.key === 'Tab' && !event.shiftKey)) {
    const nextId = that.formControlsInputId[i + 1];
    const el = document.getElementById(nextId);
    if (!el) {
      return;
    }
    event.preventDefault();
    el.click();
    el.focus();
    inputSelectAriaCheckActiveState(el.parentElement, true);
  }
}

export function setEventKeysDesktopTabReturn(that: any, document): void {
  for (let i = 0; i < that.formControlsInputId.length - 1; i++) {
    const currentId = that.formControlsInputId[i];
    const inpt = document.getElementById(currentId);
    if (!inpt) {
      continue;
    }
    inpt.addEventListener('keydown', (event) => {
      enterAndTabHandler(that, event, i);
    });
  }
}

/**
 * set Shift + Tab event on inputs
 * @param i - index of element formControlsInputId
 */
function shiftTabHandler(that: any, event, i): void {
  if (event.key === 'Tab' && event.shiftKey) {
    const nextId = that.formControlsInputId[i - 1];
    const el = document.getElementById(nextId);
    if (!el) {
      return;
    }
    event.preventDefault();
    el.click();
    inputSelectAriaCheckActiveState(el.parentElement, true);
  }
}

/**
 * just go to state as on shift tab
 *
 * go through all inputs and set
 *
 * keydown events in reverse order
 */
export function setEventKeysDesktopShiftTab(that: any, document): void {
  for (let i = that.formControlsInputId.length - 1; i > 0; i--) {
    const currentId = that.formControlsInputId[i];
    const inpt = document.getElementById(currentId);
    if (!inpt) {
      continue;
    }
    inpt.addEventListener('keydown', (event) => {
      shiftTabHandler(that, event, i);
    });
  }
}
